import Banner from '../../components/Banner';
import HistoryCollection from '../../components/HistoryCollection';
import AboutTheProject from '../../components/AboutTheProject';
import AboutTheTeam from '../../components/AboutTheTeam';
import FAQ from '../../components/FAQ';
import Hero from '../../components/Hero';
import { useBitstrayTotalSupply, useBitstrayPrice } from '../../wrappers/bitstrayToken';
import { useAppSelector } from '../../hooks';

const MainPage: React.FC = () => {
  const totalSupply = useBitstrayTotalSupply();
  const mintPrice = useBitstrayPrice();
  const lastSaleId = useAppSelector(state => state.sales.lastSaleId);

  return (
    <>
      <Hero
        totalSupply={totalSupply !== undefined ? Number(totalSupply) : 0}
        mintPrice={mintPrice}
      />
      <Banner />
      {lastSaleId && <HistoryCollection latestBitstrayId={BigInt(lastSaleId)} historyCount={10} />}

      <AboutTheProject />
      <FAQ />
      <AboutTheTeam />
    </>
  );
};
export default MainPage;
